import React from "react";
import { withStyles, Button } from "@material-ui/core";

const styles = (theme) => ({
  mainBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100wh",
    height: "100vh",
  },
  infoBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100wh",
    height: "100vh",
  },
  warnIcon: {
    width: "2.625rem",
    height: "2.625rem",
    border: "solid 1.8px #000",
    backgroundColor: theme.color.button.background_white,
    borderRadius: "50%",
    display: "flex",
    // alignItems: "center",
    justifyContent: "center",
    fontSize: theme.font.size26,
    color: theme.color.button.background_red,
    fontWeight: "bold",
    lineHeight: "1.88",
    letterSpacing: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    margin: "0 0 24px 0"
  },
  errorText1: {
    color: theme.color.input.text,
    fontSize: theme.font.size26,
    fontWeight: "bold",
    lineHeight: "1.38",
    letterSpacing: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    textAlign: "center",
    marginBottom: "1rem"
  },
  errorText2: {
    fontSize: theme.font.size16, // "15px",
    color: theme.color.input.text,
    fontWeight: "normal",
    lineHeight: "1.8",
    letterSpacing: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    margin: "4px 0",
    textAlign: "center"
  },
  button: {
    width: "-webkit-fill-available",
    margin: "0 16px 36px 16px",
    minHeight: "3.125rem",
    backgroundColor: theme.color.button.background_red,
    color: theme.color.button.text_white,
    fontSize: theme.font.size14,
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.43",
    letterSpacing: "normal",
    padding: "15px 0",
    borderRadius: "6px",
    // textTransform: "unset !important",
    // "&:active": {
    //   backgroundColor: "#08899a",
    // },
  },
});

function Sorry(props) {
  const { classes, sorryType, message, handleReload } = props;
  console.log(message);

  let title = "죄송합니다."
  let description = "잠시 후에 다시 이용해주세요."
  if (sorryType==="not_support_channel"){
    title = (<>죄송합니다.<br/>더 이상 제공되지 않는<br/>서비스입니다.</>)
    description = (<>새로워진 LG 챗봇에게<br/>궁금한 점을 말씀해주세요.</>)
  }
  return (
    <>
      <div className={classes.mainBox}>
        <div className={classes.infoBox}>
          <div className={classes.warnIcon}>!</div>
          <div className={classes.errorText1}>{title}</div>
          <div className={classes.errorText2}>{description}</div>
        </div>
        <Button type="button" className={classes.button} onClick={handleReload}>
          챗봇 다시 시작
        </Button>
      </div>
    </>
  );
}
export default withStyles(styles)(Sorry);
